import React, { Component } from "react";

class Logout extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    localStorage.removeItem("token");
    window.location.href = "/";
  }

  render() {
    return (
      <div style={{ margin: "20px" }}>
        <h2> در حال خروج...</h2>
      </div>
    );
  }
}

export default Logout;
